import classNames from 'classnames';
import type { FunctionComponent } from 'react';
import { useCallback, useState } from 'react';

import { forTemplate } from '@trello/legacy-i18n';
import { Button } from '@trello/nachos/button';
import { Checkbox } from '@trello/nachos/checkbox';
import { Spinner } from '@trello/nachos/spinner';
import { RouterLink } from '@trello/router/router-link';

import { useAcceptDeveloperTermsMutation } from './AcceptDeveloperTermsMutation.generated';

import styles from './DeveloperAgreement.less';

const format = forTemplate('app_management');

export const DeveloperAgreement: FunctionComponent<{
  refetchAgreement: () => void;
}> = ({ refetchAgreement }) => {
  const [acceptDeveloperTerms, { loading: isAccepting }] =
    useAcceptDeveloperTermsMutation();
  const [hasAgreed, setHasAgreed] = useState(false);

  const onAcceptance = useCallback(async () => {
    await acceptDeveloperTerms({
      variables: {
        memberId: 'me',
      },
    });

    refetchAgreement();
  }, [acceptDeveloperTerms, refetchAgreement]);

  return (
    <div className={classNames(styles.content, styles.developerAgreement)}>
      <div className={styles.header}>
        <h1>{format('privacy-and-compliance')}</h1>
      </div>

      <div
        // eslint-disable-next-line @eslint-react/dom/no-dangerously-set-innerhtml
        dangerouslySetInnerHTML={{
          __html: format('read-and-agree-to-the-terms'),
        }}
      />

      <div className={styles.agreeCheckContainer}>
        <Checkbox
          id="agree"
          name="agree"
          isChecked={hasAgreed}
          onChange={(e) => setHasAgreed(e.target.checked)}
          label={
            <span
              // eslint-disable-next-line @eslint-react/dom/no-dangerously-set-innerhtml
              dangerouslySetInnerHTML={{
                __html: format('acknowledge-terms'),
              }}
            />
          }
        />
      </div>

      <div className={classNames(styles.footer, styles.formFooter)}>
        <RouterLink href="/power-ups">
          <Button>{format('cancel')}</Button>
        </RouterLink>
        <Button
          appearance="primary"
          onClick={onAcceptance}
          isDisabled={!hasAgreed || isAccepting}
        >
          {isAccepting ? <Spinner small /> : format('continue')}
        </Button>
      </div>
    </div>
  );
};
